<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento das Tarifas.</span>
                <br />
                <span class="navigation">Cadastros > Tarifas</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" maxlength="500" v-model="Tarifa.nome" />
                </span>
                <small v-show="validationErrors.nome" class="p-error">Nome é Obrigatório.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="origem">Categoria: *</label>
                <span class="p-fluid">
                  <AutoComplete id="origem" v-model="selectedCategoria" :dropdown="true" :suggestions="filteredCategoria"
                    @complete="searchCategorias($event)" field="nome" placeholder="Pesquisar" />
                </span>
                <small v-show="validationErrors.origem" class="p-error">Categoria é Obrigatória.</small>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 mb-2">
                <label for="servico">Serviço:</label>
                <span class="p-fluid">
                  <AutoComplete
                    id="servico"
                    v-model="selectedServico"
                    :dropdown="true"
                    :suggestions="filteredServicos"
                    @complete="searchServico($event)"
                    field="detail"
                    placeholder="Pesquisar"
                  >
                    <template #item="slotProps">
                      <div class="p-fluid" style="max-width: 50vw">
                        {{ slotProps.item.detail }}
                      </div>
                    </template>
                  </AutoComplete>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 mb-2">
                <label for="valorPercentual">Valor Percentual: *</label>
                <span class="p-fluid">
                  <money id="valorPercentual" name="valorPercentual" v-model="Tarifa.valorPercentual" v-bind="money"
                    class="p-inputtext input-right"></money>
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/tarifaListagem">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import Tarifa from "../models/nfse/Tarifa";
import TarifaService from '../services/nfse/tarifa.service';
import CategoriaTarifaService from '../services/nfse/categoria.tarifa.service';
import ServicoService from "../services/tributario/servicos.service";

export default {
  name: "TarifaCadastro",
  data() {
    return {
      money: money,
      currentUser: null,
      loading: false,
      selectedCategoria: null,
      selectedServico: null,
      filteredServicos: null,
      filteredCategoria: null,
      Tarifa: new Tarifa(),
      validationErrors: {},
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.TarifaId = this.$route.params.id;

    if (this.TarifaId != null) {
      setTimeout(async () => {
        await TarifaService.getTarifa(this.TarifaId).then(
          response => {
            this.Tarifa = response.data;
            this.selectedCategoria = response.data.idCategoriaTarifa;
          },
          error => {
            let errorMessage = "Houve um problema ao buscar a Tarifa!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
      }, 250);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.salvar();
      this.loading = false;
    },
    searchCategorias(event) {
      setTimeout(async () => {
        this.filteredCategoria = await CategoriaTarifaService.findAllCategoriaByFiltro(this.currentUser.usuario.idCliente, event.query);
      }, 250);
    },
    searchServico(event) {
      this.processando(true);
      let dataEmissao = this.moment(new Date()).format(
        "YYYY-MM-DD"
      );
      let filtro = event.query + "*;" + dataEmissao;
      setTimeout(async () => {
        this.filteredServicos = await ServicoService.findAllByClienteFiltro(
          filtro,
          this.currentUser.usuario.idCliente
        );
        this.processando(false);
      }, 250);
    },
    salvar() {
      this.Tarifa.idCliente = this.currentUser.usuario.idCliente;
      this.Tarifa.idCategoriaTarifa = this.selectedCategoria;
      console.log(this.selectedServico);
      if (this.selectedServico) {
        this.Tarifa.idServicoItem = this.selectedServico.idServicoItem;
      }
      TarifaService.save(this.Tarifa).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Tarifa salva com sucesso"
          });
          this.$router.push("tarifaListagem");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a Tarifa!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    editarTipo() {
      this.$root.$emit("tarifa:novoTipo", this.currentUser.usuario.idCliente);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 3px;
}
</style>